
// import React, { useEffect, useState,  useRef, useContext } from "react";
// import { StyleSheet, TouchableOpacity, Image, View, Text, ScrollView, ImageBackground, TextInput } from "react-native";
// import Screen from "../components/Screen";
// //import useLocation from "../hooks/useLocation";
// //import UploadScreen from "./UploadScreen";
// //import useAuth from "../auth/useAuth";
// import connectionConfig from "../config/settings";
// import dateNow from "../utility/dateNow";
// import configurationPost from "../config/configurationPost";
// import routes from "../navigation/routes";
// import * as ImageManipulator from "expo-image-manipulator";
// import * as ImagePicker from "expo-image-picker";
// import { MaterialCommunityIcons, MaterialIcons } from "@expo/vector-icons";
// import colors from "../config/colors";
// import { Camera } from 'expo-camera';
// import { Video, Audio } from "expo-av";
// // import SignatureScreen from "react-native-signature-canvas";
// import Draggable from 'react-native-draggable'
// import  ViewShot, { captureScreen, captureRef  } from "react-native-view-shot";
// import AuthContext from "../auth/context";



// var nameDateImageAndVideo = ''
// var typeFileImageAndVideo = ''


// //var uriCapture = ''
// function AddHistoryScreen({ navigation  }) {
//     var date = dateNow()
//     var refCamera  = React.createRef()
// //const isFocused =  useIsFocused();
// const ref = useRef();
// //const refViewShot  = useRef()
// const refViewShot  = React.createRef()
// var refiel  = React.createRef()
// useEffect(() => {
//        setType(Camera.Constants.Type.front)     
//         navigation.addListener('focus', () => {
//             setCameraVisible(false)
//        // console.log('ejemplo de -> focus ;)', )
//         });
        
//         navigation.addListener('blur', () => {
//          //   console.log('ejemplo de -> blur :)', )
//             setPhoto('')
//             setSourceVideo('')
//             setIconType('camera')
//             setCameraVisible(false)
//             typeFileImageAndVideo = ''
//             nameDateImageAndVideo = ''
//               setCameraVisible(true)
//               setTextActivate(false)
//               setUriCapture(false)

//         });
//                 permissionMicrophone()
//                 permissionCamara()

// }, []);

//     //Camera hoocks
//         // Pide permiso para usar el microfono para usar la camara de video
//         const permissionMicrophone = async () => {
//            // debugger
//             setCameraVisible(true)
//             setCameraVisible(false)
//             const { status, granted }= await Camera.requestMicrophonePermissionsAsync();
//            // console.log(' const { status } requestMicrophonePermissionsAsync()', status, 'granted', granted )
//             setHasPermissionVideo(status === 'granted');   
//           if (!granted) {
//               alert('Nececitas permiso para gravar audio en la camara ')
//            // alert("You need to enable permission to access Image");
//           }
              
//         }
//     // Pide permiso para usar la camara
// const permissionCamara = async () => {
//       //  debugger

//       const { granted, status } = await  Camera.requestCameraPermissionsAsync()
//       if (!granted) {
//           alert('Nececitas permiso para la camara')
//        // alert("You need to enable permission to access Image");
//       }
//           setHasPermission(status === 'granted')
//     }
//     if (hasPermission === null) {
//         return <View />;
//     }
//     if (hasPermission === false) {
//         return <Text>No access to camera</Text>;
//     }
//     if (hasPermissionVideo === false) {
//         return <Text>No access to camera video</Text>;
//     }
//     if (hasPermissionVideo === null) {
//         return <View />;
//     }
//     const [hasPermissionVideo, setHasPermissionVideo] = useState(null);
//     const [hasPermission, setHasPermission] = useState(null);
//     const [type, setType] = useState(Camera.Constants.Type.back);

//     //const location = useLocation();
//     const [uploadVisible, setUploadVisible] = useState(false);
//     const [cameraVisible, setCameraVisible] = useState(false);

//     const [progress, setProgress] = useState(0);
//     const { user, setUser } = useContext(AuthContext);
//     //const { user } = useAuth();
//     const [textActivate, setTextActivate] = useState(false);
//     const [photo, setPhoto] = useState('');
//     const [takeVideo, setTakeVideo] = useState(false);
//     const [sourceVideo, setSourceVideo] = useState('');
//     const [status, setStatus] = useState({}); 
//     const [iconType, setIconType] = useState('camera');
//     const [uriCapture, setUriCapture] = useState(false);
//     const [textColor, setTextColor ]= useState('black')
    
//     const handleSubmit = async () => {
//         var userId = JSON.parse(user).userId
//         //debugger
//         date = dateNow()
//         if (photo != '' || sourceVideo != '' // || uriCapture != ''
//          ) {
//             if (photo.includes('.png')) {
//                 typeFileImageAndVideo = 'image/jpeg'
//                 nameDateImageAndVideo = JSON.parse(user).userId + '_' + date.replace(/ /g, '_').replace(/\//g, '-') + '_History.jpg'
//               }
//             if (photo.includes('.jpg')) {
//               typeFileImageAndVideo = 'image/jpeg'
//               nameDateImageAndVideo = JSON.parse(user).userId + '_' + date.replace(/ /g, '_').replace(/\//g, '-') + '_History.jpg'
//             }
//             if (photo.includes('.mp4')) {
//               typeFileImageAndVideo = 'application/mp4'
//               nameDateImageAndVideo = JSON.parse(user).userId + '_' + date.replace(/ /g, '_').replace(/\//g, '-') + '_History.mp4'
//             }
//             if (photo.includes('.mov')) {
//               typeFileImageAndVideo = 'video/quicktime'
//               nameDateImageAndVideo = JSON.parse(user).userId + '_' + date.replace(/ /g, '_').replace(/\//g, '-') + '_History.mov'
//             }
//             if (sourceVideo.includes('.mp4')) {
//                 typeFileImageAndVideo = 'application/mp4'
//                 nameDateImageAndVideo = JSON.parse(user).userId + '_' + date.replace(/ /g, '_').replace(/\//g, '-') + '_History.mp4'
//               }
//             if (sourceVideo.includes('.mov')) {
//                 typeFileImageAndVideo = 'video/quicktime'
//                 nameDateImageAndVideo = JSON.parse(user).userId + '_' + date.replace(/ /g, '_').replace(/\//g, '-') + '_History.mov'
//             }
//             var post_values = {
//                 userId: userId,
//                 userPublicationPhoto: nameDateImageAndVideo,
//                 createDateUserPublication: date,
//             }
//             configurationPost.body = JSON.stringify(post_values)
//             await fetch(connectionConfig.apiUrl + '/insertHistory/', configurationPost)
//             .then(response => response.json())
//            // setProgress(0.5);
//              savePhoto()
//             .catch(err => {
//                 console.log('Insert fixo failed :( review internet service -> /insertHistory/', err)
//             })
//         }else{
//                 alert('Toma una imagen para tu historia')
//         }
// };

// //--------------------------------------------- 
// //Rutina para guardar una foto o video
// //---------------------------------------------
// const savePhoto = async () => {
//     let quality = 0.1
//    if (Platform.OS === 'android') {
//       quality = 0.5
    
//   } else {
//       quality = 0.05
//   }
//     //debugger
//     try {
//       const formData = new FormData()
//       if (typeFileImageAndVideo === 'image/jpeg') {
//         const manipResult = await ImageManipulator.manipulateAsync(
//           photo,// === '' ? uriCapture : photo,
//           [],
//           { compress: quality, format: ImageManipulator.SaveFormat.JPEG })
//         formData.append('photoAndVideo', {
//           uri: manipResult.uri,
//           type: typeFileImageAndVideo,
//           name: nameDateImageAndVideo,
//         })
//       }
//       if (typeFileImageAndVideo === 'application/mp4') {
//         formData.append('photoAndVideo', {
//           uri: photo != '' ? photo : sourceVideo,
//           type: typeFileImageAndVideo,
//           name: nameDateImageAndVideo,
//         })
//       }
//       if (typeFileImageAndVideo === 'video/quicktime') {
//         formData.append('photoAndVideo', {
//           uri: photo != '' ? photo : sourceVideo,
//           type: typeFileImageAndVideo,
//           name: nameDateImageAndVideo,
//         })
//       }
//       const configurationPost = {
//         method: 'POST',
//         headers: {
//           'Accept': 'application/json',
//           'Content-Type': 'multipart/form-data'
//         },
//         body: formData
//       }
//       // post Para guardar imagen de perfil
//       fetch(connectionConfig.apiUrl + '/upload_infoPhotoAndVideo', configurationPost)
//         .then(response => response.json())
//         .then(response => {
//           //debugger
//          // setProgress(1)
//           setPhoto('')
//           setSourceVideo('')
//           setIconType('camera')
//           setCameraVisible(false)
//           typeFileImageAndVideo = ''
//           nameDateImageAndVideo = ''
//           navigation.navigate(routes.NO_BOTTON )
//           if (response.data === 'descarga-> error') {
//             console.log("maintennance server descarga-> error /upload_infoPhotoAndVideo")
//           }
//         })
//         .catch((err) => {
//           alert("Entre en el penultimo catch de addseed", err)
//        //   setProgress(1)
//           console.log("maintennance server -> catch /upload_infoPhotoAndVideo", err)
//         })
//     } catch (error) {
//       alert("Entre en último catch de addseed", err)
// //setProgress(1)
//       console.log("maintennance server -> catch Final /upload_infoPhotoAndVideo", error)
//     }
//   }

// //--------------------------------------------------
// //  Select Image es la función que te permite sacar
// //  la biblioteca de imagenes de tu Cel 
// //--------------------------------------------------
//     const selectImage = async () => {
//         try {
//             const result = await ImagePicker.launchImageLibraryAsync()
//             debugger
//             if(!result.cancelled){
//             setCameraVisible(true)
//             setIconType('')
//             setPhoto(result.uri)
//                 //setImageUri(result.uri)
//             }else{
//                 setPhoto('')
//                 setCameraVisible(false)
//             }
//         } catch (error) {
//             console.log("error al leer imagen", error)
//         }
//     }

// //---------------------------------------------------------
// //rutina para tomar una foto a traves de la libreria camera
// //---------------------------------------------------------
//  const takePhoto = async () => {
//         if(sourceVideo !== ''){
//                 setSourceVideo('')
//         }       
//             try {
//                 const result = await refCamera.current.takePictureAsync({
//                     quality: 0.1,
//                 })
//                 //debugger
//                 if (!result.cancelled)
//                     setCameraVisible(true)
//                     setPhoto(result.uri)
//             } catch (error) {
//                 console.log("error al leer imagen", error)
//             }
// }
// //------------------------------------
// //rutina que comienza a toma video
// //----------------------------------
//     const takeVideoBtn = async () => {
//         setTakeVideo(true)
//         if(photo !== ''){
//             setPhoto('')
//         }
//         try {
            
//             console.log("video entre")
//             if(type === Camera.Constants.Type.back){
//              const result = await refCamera.current.recordAsync(
//                 {
//                 quality: 0.1,
//             }
//             ) 
//             console.log("result", result.uri)
//             if (!result.cancelled)
//             setCameraVisible(true)
//              setSourceVideo(result.uri)
//           }else{
//            const resultFront = await refCamera.current.recordAsync()
//            console.log("resultFront", resultFront.uri)
//            if (!resultFront.cancelled)
//            setCameraVisible(true)
//             setSourceVideo(resultFront.uri)
//           }
//             //debugger
//         } catch (error) {
//             console.log("error al leer imagen video", error)

//         }
//     }
// //-------------------------------
// //rutina para parar un video 
// //----------------------------
// const stopVideoRecording = () => {   
// if (refCamera.current) {
//     refCamera.current.stopRecording();
//     setTakeVideo(false)
//     }
// }
// //------------------------------------------
// //rutina para tomar una captura de pantalla 
// //-----------------------------------------
// const  screenCaptureAction = async () => {  
//  setTextActivate(true)
//  setUriCapture(false)
// debugger
//  refViewShot.current.capture() 
//  .then(uri => {
//     setPhoto(uri)
//     console.log("uri temporal captura view -> ",  uri);
//   });
//   console.log("photo ", photo);
// }
//  //-------------------------------------------------
//  //función para cambiar de color el texto del input
//  //------------------------------------------------
//    const handleColor = (color) => {
//     console.log('entra a handleColor-> ', color)
//     console.log('typeof(ref.current)-> ', typeof(ref.current))
//     setTextColor(color)
//     if (typeof(ref) !== undefined) {
//       if (typeof(ref.current) === 'object') {
//         ref.current.changePenColor(color)
//         console.log('cambia a color -> ', color)
//       }
//     }
//   }

//     return (
//         <Screen style={styles.container}>

//             <ScrollView>
//                 {/* <UploadScreen
//                     onDone={() => setUploadVisible(false)}
//                     progress={progress}
//                     visible={uploadVisible}
//                 /> */}

//                     {
//                         photo === '' ?
//                             null
//                             :
//                         <>
//                             <View style={styles.containerClose}>
//                                 <MaterialCommunityIcons
//                                     name="close"
//                                     size={44} color="black"
//                                     onPress={() => {
//                                         setPhoto('')
//                                         setIconType('camera')
//                                         setSourceVideo('')
//                                         setCameraVisible(false)
//                                     }}
//                                 />
//                                       <MaterialCommunityIcons
//                                        //style={styles.buttonFlip}
//                                         onPress={() => {
//                                             setTextActivate(
//                                                 textActivate === true
//                                                     ? false
//                                                     : true
//                                             );
//                                             setUriCapture(
//                                                 textActivate === true
//                                                 ? false
//                                                 : true)
//                                         }}
//                                         name="text-recognition" size={44}
//                                          color="black"
//                                     />
                               
//                                    {
//                                        textActivate === true ?
//                                         <>  
//                                             <TouchableOpacity style={styles.colorWhite} onPress={() => handleColor('white')} />
//                                             <TouchableOpacity style={styles.colorBlack} onPress={() => handleColor('black')} />
//                                             <TouchableOpacity style={styles.colorRed} onPress={() => handleColor('red')} />
//                                             <TouchableOpacity style={styles.colorBlue} onPress={() => handleColor('blue')} />
//                                             <TouchableOpacity style={styles.colorGreen} onPress={() => handleColor('green')} />
//                                             <TouchableOpacity style={styles.colorYellow} onPress={() => handleColor('yellow')} />
//                                         </>
//                                         :
//                                         null
//                                    }
                                   
//                              </View>
//                                 {
//                                     iconType === 'camera' ?
//                                     <ViewShot ref={refViewShot}>
//                                     <ImageBackground style={styles.imageCamera} source={{ uri: photo }} />
//                                     {
//                                     textActivate === false ?
//                                     null
//                                     : textColor === 'blue' ?
//                                     <Draggable x={10} y={10}>
//                                         <TextInput style={styles.inpTxtBlue}>Escribe algo en tu historia</TextInput>
//                                     </Draggable> 
//                                     : textColor === 'green' ?
//                                     <Draggable x={10} y={10}>
//                                         <TextInput style={styles.inpTxtGreen}>Escribe algo en tu historia</TextInput>
//                                     </Draggable> 
//                                     : textColor === 'yellow' ?
//                                      <Draggable x={10} y={10}>
//                                          <TextInput style={styles.inpTxtYellow}>Escribe algo en tu historia</TextInput>
//                                      </Draggable> 
//                                     :  textColor === 'red' ?
//                                       <Draggable x={10} y={10}>
//                                           <TextInput style={styles.inpTxtRed}>Escribe algo en tu historia</TextInput>
//                                       </Draggable> 
//                                       : textColor === 'white' ?
//                                        <Draggable x={10} y={10}>
//                                            <TextInput style={styles.inpTxtWhite}>Escribe algo en tu historia</TextInput>
//                                        </Draggable> :                                     
//                                         <Draggable x={10} y={10}>
//                                             <TextInput style={styles.inpTxtBlack}>Escribe algo en tu historia</TextInput>
//                                         </Draggable> 
//                                     }
//                                      </ViewShot>
//                                     :
//                                      <TouchableOpacity onPress={selectImage}>
//                                      <ImageBackground style={styles.imageCamera} source={{ uri: photo }} >
//                                      </ImageBackground>
//                                      </TouchableOpacity>
//                                 }                      
//                         </>
//                     }
                    
//                      {cameraVisible === false ?
//                         <>

//                             <Camera style={styles.imageCamera}
//                                 type={type}
//                                 //onFacesDetected={}
//                                 ref={refCamera}
//                             >
//                                 <View style={styles.buttonContainer}>
//                                     <MaterialCommunityIcons
//                                         style={styles.buttonFlip}
//                                         onPress={() => {
//                                             setType(
//                                                 type === Camera.Constants.Type.back
//                                                     ? Camera.Constants.Type.front
//                                                     : Camera.Constants.Type.back
//                                             );
//                                         }}
//                                         name="camera-retake-outline" size={44}
//                                          color="white"
//                                     />
//                                 {
//                                 iconType === 'camera' ? 
//                                     <MaterialCommunityIcons
//                                         style={styles.iconButton}
//                                         onPress={() => {
//                                             // setCameraVisible(true)
//                                            takePhoto()
//                                           //screenCaptureAction()
//                                         }}
//                                         name="checkbox-blank-circle-outline" size={64} color={colors.white}
//                                     />
//                                      :                                 
//                                      takeVideo === false ?
//                                     <MaterialCommunityIcons
//                                     style={styles.iconButtonVideo}
//                                     onPress={() => {
//                                         takeVideoBtn()                              
//                                     }}
//                                     name="checkbox-blank-circle-outline"
//                                     size={64} 
//                                     color={colors.white} 
//                                     //style={styles.back}
//                                      />
//                                     :
//                                     <MaterialCommunityIcons
//                                     style={styles.iconButton}
//                                     onPress={() => {
//                                         stopVideoRecording()
//                                         }
//                                     }
//                                     name="checkbox-blank-circle-outline" 
//                                     size={64} color={colors.blueFollow} 
//                                     />

//                                 }                               
//                                 </View>
//                             </Camera>
//                             {
//                                 iconType === 'camera' ? 
//                                 <>
  
//                                 <MaterialCommunityIcons
//                                     onPress={() => {
//                                         setIconType('camera')
//                                     }}
//                                     name="camera"
//                                     size={60}
//                                     color={colors.fuente}
//                                     style={styles.iconCamara}
//                                  />
//                                 <MaterialCommunityIcons
//                                     onPress={() => {
//                                         setIconType('cameraVideo')
//                                     }}
//                                     name="video-box"
//                                     size={60}
//                                     color={colors.white}
//                                     style={styles.iconCamaraVideo}
//                                 />
//                                 <TouchableOpacity onPress={selectImage} style={styles.imageLibrary}>
//                                 <MaterialIcons                              
//                                     name={"photo-library"}
//                                     size={60}
//                                     color={colors.white}
//                                 />                      
//                                  </TouchableOpacity>
//                             </>
//                             :
//                             <>
//                                 <MaterialCommunityIcons
//                                 onPress={() => {
//                                     setIconType('camera')
//                                 }}
//                                 name="camera"
//                                 size={60}
//                                 color={colors.white}
//                                 style={styles.iconCamara}
//                                 />
//                                 <MaterialCommunityIcons
//                                 onPress={() => {
//                                     setIconType('cameraVideo')
//                                 }}
//                                 name="video-box"
//                                 size={60}
//                                 color={colors.fuente}
//                                 style={styles.iconCamaraVideo}
//                                 />
//                                 <TouchableOpacity onPress={selectImage} style={styles.imageLibrary}>
//                                 <MaterialIcons                              
//                                     name={"photo-library"}
//                                     size={60}
//                                     color={colors.white}
//                                 />          
//                                 </TouchableOpacity>
//                             </>
//                             }
                          
                        
//                         </> 
//                         :
//                         sourceVideo !== '' ?
//                         <>
//                          <MaterialCommunityIcons
//                              name="close"
//                             size={44} color="black"
//                              onPress={() => {
//                                 setPhoto('')
//                                 setIconType('camera')
//                                 setSourceVideo('')
//                                 setCameraVisible(false)
//                                  }}
//                             />        
//                         <Video 
//                         style = {styles.imageCamera}
//                         source = {{ uri: sourceVideo }}
//                         useNativeControls
//                         resizeMode = "contain"
//                         isLooping
//                         onPlaybackStatusUpdate = {status => setStatus(() => status)}
//                        />
//                        </>
//                         :
//                         null
//                      }
//                     {
//                     uriCapture === false ?
//                     <TouchableOpacity onPress={handleSubmit} >
//                         <View style={styles.submitBtn}>
//                             <Text style={styles.txtbutton}>Crear historia</Text> 
//                         </View>
                                                     
//                     </TouchableOpacity>
//                     :
//                     <TouchableOpacity onPress={screenCaptureAction} >
//                         <View style={styles.submitBtn}>
//                             <Text style={styles.txtbutton}>Listo</Text> 
//                         </View>
                                                     
//                     </TouchableOpacity>
//                     }                     
//             </ScrollView>
//         </Screen>
//     );
// }

// const styles = StyleSheet.create({
//     container: {
//         padding: 10,
//     },
//     imagePhoto: {
//         width: 200,
//         height: 200,
//         alignSelf: "center",
//         marginBottom: 20,
//         borderRadius: 5,
//     },
//     imageCamera: {
//         width: '100%',
//         height: 480,
//         alignSelf: "center",
//         marginBottom: 20,
//         borderRadius: 5,
//     },
//     back:{
//         backgroundColor: colors.primary
//     },
//     iconButton: {
//         //flex: 0.1,
//         marginTop: '65%',
//         alignSelf: 'center',
//         alignItems: 'center',
//         //backgroundColor: colors.primary
//     },
//     iconButtonVideo: {
//         //flex: 0.1,
//         marginTop: '65%',
//         alignSelf: 'center',
//         alignItems: 'center',
//         backgroundColor: colors.primary,
//         borderRadius:35
//     },
//     iconCamara: {
//         marginTop:'117%',
//         marginLeft:'10%',
//         position:'absolute'
//     },
//     iconCamaraVideo:
//     {
//         marginTop:'116%',
//         marginLeft:'70%',
//         position:'absolute'
//     },
//     imageLibrary:{
//         marginTop:'116%',
//         marginLeft:'40%',
//         position:'absolute'
//     },
//     submitBtn:{       
//         marginTop:'3%',
//         marginLeft:'9%',
//         width:'80%',
//         height:50,
//         color:colors.secondary,
//         backgroundColor: colors.green,
//         borderRadius: 10
//     },
//     txtbutton:{
//         marginTop:'2%',
//         fontSize:27, 
//          marginLeft:'22%',
//     },
//     inpTxtBlue:{
//         fontSize:25, 
//         color: colors.blueFollow
//     },
//     inpTxtGreen:{
//         fontSize:25, 
//         color: colors.green
//     },
//     inpTxtRed:{
//         fontSize:25, 
//         color: colors.primary
//     },
//     inpTxtBlack:{
//         fontSize:25, 
//         color: colors.black,
//         //fontFamily:'Comic Sans'
//     },
//     inpTxtYellow:{
//         fontSize:25, 
//         color: colors.yellow
//     },
//     inpTxtWhite:{
//         fontSize:25, 
//         color: colors.white
//     },
//     containerClose:{
//         flexDirection: 'row'
//     },
//     colorBlack: {
//         color: 'black',
//         backgroundColor: 'black',
//         marginTop: 20,
//         width: 30,
//         height: 30,
//         justifyContent: 'center',
//         alignItems: 'center',
//         padding: 10,
//         borderRadius: 100,
//       },
//       colorRed: {
//         color: 'red',
//         backgroundColor: 'red',
//         marginTop: 20,
//         width: 30,
//         height: 30,
//         justifyContent: 'center',
//         alignItems: 'center',
//         padding: 10,
//         borderRadius: 100,
//       },
//       colorBlue: {
//         color: 'blue',
//         backgroundColor: 'blue',
//         marginTop: 20,
//         width: 30,
//         height: 30,
//         justifyContent: 'center',
//         alignItems: 'center',
//         padding: 10,
//         borderRadius: 100,
//       },
//       colorYellow: {
//         color: 'yellow',
//         backgroundColor: 'yellow',
//         marginTop: 20,
//         width: 30,
//         height: 30,
//         justifyContent: 'center',
//         alignItems: 'center',
//         padding: 10,
//         borderRadius: 100,
//       },
//       colorWhite: {
//         color: 'white',
//         backgroundColor: colors.white,
//         marginTop: 20,
//         borderColor: 'black',
//         borderWidth: 2,
//         width: 30,
//         height: 30,
//         justifyContent: 'center',
//         alignItems: 'center',
//         padding: 10,
//         borderRadius: 100,
//       },
//       colorGreen: {
//         color: 'green',
//         backgroundColor: 'green',
//         marginTop: 20,
//         width: 30,
//         height: 30,
//         justifyContent: 'center',
//         alignItems: 'center',
//         padding: 10,
//         borderRadius: 100,
//       },
// });

// export default AddHistoryScreen;
import React from "react";
import { StyleSheet, Text, TouchableOpacity } from "react-native";

import colors from "../config/colors";

function AddHistoryScreen({ title, txtStyle = '', btnStyle = '', onPress, color = "primary" }) {
  return (
    <TouchableOpacity
      style={btnStyle === '' ? [styles.button, { backgroundColor: colors[color] }] : [btnStyle, { backgroundColor: colors[color] }]}
      onPress={onPress}
    >
      <Text style={txtStyle === '' ? styles.text : txtStyle}>{title}</Text>
    </TouchableOpacity>
  );
}

const styles = StyleSheet.create({
  button: {
    backgroundColor: colors.primary,
    borderRadius: 25,
    justifyContent: "center",
    alignItems: "center",
    padding: 15,
    width: "100%",
    marginVertical: "0.2%",
  },
  text: {
    color: colors.white,
    fontSize: 18,
    textTransform: "uppercase",
    fontWeight: "bold",
  },
});

export default AddHistoryScreen;
